<template>
  <div class="container app-container">
    <el-form :inline="true" ref="search" :model="search" class="demo-form-inline">
      <el-form-item prop="title">
        <el-input v-model="search.title" placeholder="请输入护理站名称"></el-input>
      </el-form-item>
      <el-form-item prop="area">
        <el-input v-model="search.area" placeholder="请输入所属城市"></el-input>
      </el-form-item>
      <el-form-item prop="status">
        <el-select v-model="search.status" placeholder="护理站状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="上架" value="1"></el-option>
          <el-option label="下架" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleInsertNurseStation">创建护理站</el-button>
        <el-button type="primary" @click="searchData">查询</el-button>
        <el-button @click="resetForm('search')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column
        type="index"
        label="序号"
        width="50">
        <template slot-scope="{$index}"> {{ $index + ((page_number - 1) * page_size ) + 1 }}</template>
      </el-table-column>
      <el-table-column prop="title" label="护理站名称" align="center" />
      <el-table-column prop="status" label="护理站状态" align="center">
        <template slot-scope="{ row }">
          {{ row.status | toNurseStationStatusText }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" align="center">
        <template slot-scope="{ row }">
          {{  (row.created_at * 1000) | formatDate('yyyy-MM-dd') }}
        </template>
      </el-table-column>
      <el-table-column prop="area" label="所属城市" align="center" />
      <el-table-column label="上下架">
        <template slot-scope="{ row: { status, id }}">
          <div @click="changeStatus(id, status)">
            <el-switch :value="status === 1"></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{ row }">
          <i class="el-icon-tickets fz24" title="详情" @click="handleEditNurseStation(row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        :current-page="page_number"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

  </div>
</template>

<script>
import { formatDate } from 'element-ui/lib/utils/date-util'
import { changeStatusForStation, fetchStationList } from '../../api'
export default {
  name: 'NursingStationManagement',
  data() {
    return {
      search: {
        title: '',
        area: '',
        status: ''
      },
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      nurseAddressList: [],
      tableData: [],
      regionList: []
    }
  },
  filters: {
    formatDate,
    toNurseStationStatusText(val) {
      return {
        '0': '已下架',
        '1': '已上架'
      }[val] || '-'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    changeStatus(id, status) {
      const params = {
        id,
        status: status === 1 ? 0 : 1
      }
      changeStatusForStation(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.init()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    init() {
      // status 0 超级管理员 1无权限 2有权限 默认1无权限
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    handleInsertNurseStation() {
      this.$router.push({
        path: '/nurse-station-insert'
      })
    },
    // 编辑护理站
    handleEditNurseStation(station) {
      this.$router.push({
        path: '/nurse-station-edit',
        query: {
          id: station.id
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    regionBlurFn() {
      this.search.address = ''
    },
    getList() {
      this.tableLoading = true
      const { page_size, page_number, search } = this
      const { ...searchInfo } = search
      const params = {
        pageSize: page_size,
        pageNumber: page_number,
        ...searchInfo
      }
      this.tableLoading = true
      fetchStationList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;

  .imgbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .litimg {
      width: 30px;
      height: 30px;
      margin: 3px;
      object-fit: cover;
      cursor: zoom-in;
    }
  }

  .picture {
    width: 100%;
  }

  .block {
    text-align: center;
  }

  .el-pagination {
    margin-top: 20px;
  }

  .total {
    padding: 0 6% 15px;
    color: #26A4B2;
    text-align: right;
    font-weight: bold;
  }
}
</style>
